module.exports = __webpack_public_path__ + "static/img/br_head_wr.3af7edde.webp";